import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import TableMgtOrg from './TableMgtOrg'

import AuthService from '../../service/Auth'
import Actions from '../../redux/actions'

const Container = styled.div`

`;

export default function Index(props) {

    const dispatch = useDispatch()
    const [permission, setPermission] = useState('')

    useEffect(() => {
        dispatch(Actions.master.setPath("/mgt-org"))
        const init = async() =>{
            let permission = await AuthService.permission('mgt-org')
            if(permission) setPermission(permission)
        }

        init()
    }, [dispatch])
    
    return (
        <Container className={"section-mgt-org" + (props.className ? props.className : "")}>
            <div className="page-title">
                <img src='./image/mgt-org.png' alt="icon-org"/>
                <span>จัดการหน่วยงาน</span>
            </div>
            <div className="table-container">
                <TableMgtOrg permission={permission}/>
            </div>
        </Container>
    )
}